import type { MediaSummary } from '../../shared/contracts'

export function matchesLibrarySearch(media: MediaSummary, query: string): boolean {
    const keywords = query.trim().toLocaleLowerCase().split(/\s+/u).filter(Boolean)
    if (!keywords.length) { return true }
    const searchable = [
        media.title,
        media.originalTitle,
        media.year,
        media.category,
        media.remarks,
        media.sourceName,
    ].filter((value): value is string => typeof value === 'string').join('\n').toLocaleLowerCase()
    return keywords.every(keyword => searchable.includes(keyword))
}
